import { HdAPI } from './types'
import queryString from 'query-string'
import { format } from 'date-fns'

export const hdApi: HdAPI = ky => {
  return {
    async fetch({ patientId, cursor, currentTab }) {
      return ky(`patient/${patientId}/hd/`, {
        method: 'get',
        searchParams: queryString.stringify({ cursor, currentTab })
      }).json()
    },

    async update({ patientId, hdId, payload }) {
      return await ky(`patient/${patientId}/hd/${hdId}/`, {
        method: 'patch',
        body: JSON.stringify(payload)
      }).json()
    },

    async finish({ patientId, hdId, payload }) {
      const date: Date = new Date()
      const formattedDate: string = format(date, 'YYYY-MM-DD HH:mm:ss')
      const edtime = { endDatetime: formattedDate }
      Object.assign(payload, edtime)
      return await ky(`patient/${patientId}/hd/${hdId}/`, {
        method: 'patch',
        body: JSON.stringify(payload)
      }).json()
    },

    async create({ patientId, payload }) {
      return await ky(`patient/${patientId}/hd/`, {
        method: 'post',
        body: JSON.stringify(payload)
      }).json()
    },

    async fetchSetting({ patientId }) {
      return ky(`patient/${patientId}/hd_setting/`, {
        method: 'get'
      }).json()
    },

    async createSetting({ patientId, payload }) {
      return ky(`patient/${patientId}/hd_setting/`, {
        method: 'post',
        body: JSON.stringify(payload)
      }).json()
    }
  }
}
